import { render, staticRenderFns } from "./OrcamentoList.vue?vue&type=template&id=02638e37&scoped=true"
import script from "./OrcamentoList.vue?vue&type=script&lang=js"
export * from "./OrcamentoList.vue?vue&type=script&lang=js"
import style0 from "./OrcamentoList.vue?vue&type=style&index=0&id=02638e37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02638e37",
  null
  
)

export default component.exports